import { PiWarningCircleFill } from "react-icons/pi";
import GeneralButton from "../button/GeneralButton";
import { IoCloseSharp } from "react-icons/io5";
import { Modal, ModalBody, Row } from "reactstrap";

const DeleteItemModal = ({ modal, toggle, productId, index, handleDelete }) => {
  const handleYesClick = () => {
    handleDelete(productId, index);
    toggle();
  };
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="md">
      <ModalBody className="p-2">
        <div className="d-flex justify-content-end align-items-center mb-2">
          <IoCloseSharp size={"30"} onClick={toggle} className="pointer" />
        </div>
        <Row className="mb-3">
          <div className="d-flex justify-content-center align-items-center flex-column">
            <PiWarningCircleFill size={100} className="text-danger " />
            <h2 className="text-center my-3 text-secondary text-capitalize">
              Are you Sure you want to Delete ?
            </h2>
            <div className="d-flex justify-content-end">
              <GeneralButton
                title={"No"}
                className={"white-button mx-2"}
                width={"140px"}
                handleClick={toggle}
              />
              <GeneralButton
                title={"Yes"}
                className={"blue-button"}
                width={"140px"}
                handleClick={handleYesClick}
              />
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default DeleteItemModal;
